import { atom, useAtom } from "jotai";
import { Item, ItemsGroup } from "types";

export type ItemsState = {
  checkedItems: Item[];
};

type UseItemsReturn = {
  itemsState: ItemsState;
  setItemsState: React.Dispatch<React.SetStateAction<ItemsState>>;
};

export const allItemsAtom = atom<Item[]>([]);
export const allItemsGroupsAtom = atom<ItemsGroup[]>([]);

export const itemsAtom = atom<ItemsState>({
  checkedItems: [],
});

export const useItems = (): UseItemsReturn => {
  const [itemsState, setItemsState] = useAtom(itemsAtom);

  return { itemsState, setItemsState };
};
